export default "__VITE_ASSET__CcYye6zJ__"